import { render, staticRenderFns } from "./AdminRolesComponent.vue?vue&type=template&id=10a587d8&"
import script from "./AdminRolesComponent.vue?vue&type=script&lang=js&"
export * from "./AdminRolesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports